import { Link, createFileRoute } from "@tanstack/react-router";

import { Card } from "../components/ui";
import { ForgotPasswordForm } from "../features/auth/PasswordResetForms";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const t = useT();
  return (
    <main className="mx-auto w-full max-w-md px-4 py-10">
      <Card title={t("auth.forgot.title")}>
        <ForgotPasswordForm />
        <p className="mt-4 flex flex-col gap-1 text-sm">
          <Link to="/login">{t("auth.forgot.back")}</Link>
        </p>
      </Card>
    </main>
  );
}
